import { httpPost } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';

/**
 * Requests password reset of user with provided email address
 *
 * @method requestPasswordChange
 * @memberof Password
 * @param  {string} email - Email to lookup and send password reset request to
 * @returns {Promise<boolean>} - True/false success of request
 */

export const requestPasswordChange = async (email: string): Promise<boolean> => {
  return httpPost(`${Constants.BACKEND_URL}/auth/password-reset/email`, { email })
    .then((response) => {
      if (response?.status === 200 && response?.data.success) {
        return true;
      }

      return false;
    })
    .catch((error) => {
      throw Error(`Error requesting password reset: ${error}`);
    });
};
